import { fetchApi } from "@inmagik/react-crud"
import { Alert, Box, Button, TextField, Typography } from "@mui/material"
import { Formik, getIn } from "formik"
import { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { API_URL } from "../../constants"
import yup from "../../utils/validations"

export function PasswordDimenticata() {
  const [confirm, setConfirm] = useState(false)
  const { t } = useTranslation()
  const schema = useMemo(() => {
    return yup.object().shape({
      email: yup.string().email().required().label(t("lost_password.schema_email_label")),
    })
  }, [t])
  const initialValues = {
    email: "",
  }
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        p={3}
        borderRadius={1}
        boxShadow={3}
        minWidth={395}
        maxWidth={464}
      >
        <Box display="flex" flexDirection="column" alignItems="center" gap={1} marginBottom={4} width="100%">
          <Typography
            variant="h5"
            sx={{
              fontWeight: 500,
              textAlign: "center",
              color: "rgba(0, 0, 0, 0.87)",
            }}
          >
            {t("lost_password.title")}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontSize: "15px",
              lineHeight: "133.4%",
              color: "#757575",
            }}
          >
            {t("lost_password.subtitle")}
          </Typography>
        </Box>
        <Formik
          validationSchema={schema}
          initialValues={initialValues}
          enableReinitialize
          onSubmit={async (values) => {
            await fetchApi(API_URL + "/userbase/recover-password/", {
              method: "POST",
              body: JSON.stringify(values),
              responseType: "raw",
              headers: {
                "Content-Type": "application/json",
              },
            }).then(() => {
              setConfirm(true)
            })
          }}
        >
          {({ handleSubmit, errors, values, setFieldValue, isSubmitting, isValid }) => (
            <form onSubmit={handleSubmit} style={{ width: "100%" }} noValidate>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                width="100%"
                gap={1}
                marginBottom={confirm ? 2 : 4}
              >
                <TextField
                  label={t("lost_password.email")}
                  type="email"
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  value={values.email}
                  onChange={(e) => setFieldValue("email", e.target.value)}
                  helperText={getIn(errors, "email")}
                  error={getIn(errors, "email") ? true : false}
                  required
                />
              </Box>
              {confirm && (
                <Alert severity="success" sx={{ marginBottom: 2, width: "100%" }}>
                  {t("lost_password.success_recover")}
                  <Link to="/login">{t("lost_password.login")}</Link>
                </Alert>
              )}
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                loading={isSubmitting}
                disabled={!values.email || !isValid || isSubmitting}
                fullWidth
              >
                {t("lost_password.cta_recover")}
              </Button>
            </form>
          )}
        </Formik>
      </Box>
    </Box>
  )
}
